import React from "react";
import { ArrowRight, MapPin } from "lucide-react";

export default function DestinationsSection({
  id,
  eyebrow,
  title,
  subtitle,
  ctaLabel = "Start Exploring",
  items,
  bg = "cream",
}) {
  const bgStyles = {
    cream: "bg-[#FBF6EC]",
    white: "bg-white",
    mint: "bg-[#E7F3F2]",
  };

  return (
    <section id={id} className={`${bgStyles[bg]} py-16 md:py-24`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
          <div>
            {eyebrow && (
              <p className="uppercase tracking-[0.3em] text-[#1F5B63] text-xs font-bold mb-3">
                {eyebrow}
              </p>
            )}
            <h2
              className="text-3xl md:text-5xl text-slate-900 font-light leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {title}
            </h2>
            {subtitle && (
              <p className="text-slate-600 mt-3 max-w-xl">{subtitle}</p>
            )}
          </div>
          <button className="group inline-flex items-center gap-2 text-[#1F5B63] font-semibold border-b-2 border-[#1F5B63]/40 pb-1 self-start hover:border-[#1F5B63] transition-colors">
            {ctaLabel}
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {items.map((item, idx) => (
            <a
              key={item.name + idx}
              href="#top"
              className="group relative overflow-hidden rounded-2xl aspect-[3/4] shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-1"
            >
              <img
                src={item.image}
                alt={item.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 text-white">
                <div className="flex items-center gap-1 text-white/80 text-[11px] uppercase tracking-widest mb-1">
                  <MapPin className="h-3 w-3" />
                  Explore
                </div>
                <h3 className="text-lg md:text-xl font-bold leading-tight">
                  {item.name}
                </h3>
                {item.price && (
                  <p className="text-white/90 text-sm mt-1">
                    from <span className="font-semibold">{item.price}</span>
                  </p>
                )}
              </div>
              <div className="absolute top-3 right-3 h-9 w-9 rounded-full bg-white/95 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <ArrowRight className="h-4 w-4 text-[#1F5B63]" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
